import React, { useState } from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import aboutFingoData from '../../constants/team/about';
import Marquee from '../../components/animations/Marquee';
import { getCdnUrl } from '../../helpers';
import {
  STACK_CENTER,
  STACK_CENTER_COLUMN_DIRECTION,
  STACK_START_COLUMN_DIRECTION,
  STACK_CENTER_ROW_DIRECTION,
  ENTITIES_LIST_CLASS_NAME,
} from '../../constants/mui-components';
import {
  containerStack,
  contentStack,
  headerSection,
  titleContainer,
  titleTypography,
  descriptionTypography,
  commentIcon,
  commentTypography,
  missionVisionContainer,
  missionVisionStack,
  missionVisionItem,
  missionVisionTitleTypography,
  missionVisionTextTypography,
  videoCard,
  videoStyles,
} from './styles/about.styles';

function About() {
  const theme = useTheme();
  const [started, setStarted] = useState(false);
  const widthCardAnimation = 24;
  const gapCardAnimation = 2;
  const distanceAnimation = (widthCardAnimation + gapCardAnimation) * aboutFingoData.videos.length;
  const distance = `${distanceAnimation}rem`;
  return (
    <Stack className={STACK_CENTER} sx={containerStack}>
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={contentStack}>
        <Stack sx={headerSection}>
          <Stack
            className={STACK_START_COLUMN_DIRECTION}
            sx={titleContainer}
          >
            <Typography variant="xlarge_2" sx={titleTypography}>
              {aboutFingoData.title}
            </Typography>
            <Typography variant="medium_1" sx={descriptionTypography}>
              {aboutFingoData.description}
            </Typography>
          </Stack>
          <Grid container columnSpacing={15} rowSpacing={2}>
            {aboutFingoData.staffComments.map((comment) => (
              <Grid item xs={12} md={6}>
                <Stack
                  className={STACK_CENTER_ROW_DIRECTION}
                  key={comment.id}
                  gap="1rem"
                >
                  <CardMedia
                    component="img"
                    image={comment.icon}
                    alt={comment.text}
                    style={commentIcon}
                  />
                  <Typography variant="medium_1" sx={commentTypography}>
                    {comment.text}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Stack>
        <Marquee direction="left" speed={20} fade distance={distance}>
          <MenuList
            className={ENTITIES_LIST_CLASS_NAME}
            gap={`${gapCardAnimation}rem`}
          >
            {aboutFingoData.videos.map((video) => (
              <Fade in={started} timeout={2000}>
                <Card
                  key={video.id}
                  sx={videoCard(widthCardAnimation, video.id !== aboutFingoData.videos.length - 1)}
                >
                  <video
                    key={video.id}
                    autoPlay
                    muted
                    loop
                    playsInline
                    onCanPlay={() => setStarted(true)}
                    style={videoStyles}
                  >
                    <source src={getCdnUrl(`/videos/${video.src}`)} type="video/mp4" />
                    <track
                      kind="captions"
                      src=""
                      srcLang="es"
                      label="Sin subtítulos"
                    />
                  </video>
                </Card>
              </Fade>
            ))}
          </MenuList>
        </Marquee>
        <Stack className={STACK_CENTER} sx={missionVisionContainer}>
          <Stack sx={missionVisionStack}>
            <Stack sx={missionVisionItem}>
              <Typography variant="xlarge_2" sx={missionVisionTitleTypography(theme)}>
                {aboutFingoData.missionTitle}
              </Typography>
              <Typography variant="medium_1" sx={missionVisionTextTypography(theme)}>
                {aboutFingoData.missionText}
              </Typography>
            </Stack>
            <Stack
              sx={missionVisionItem}
            >
              <Typography variant="xlarge_2" sx={missionVisionTitleTypography(theme)}>
                {aboutFingoData.visionTitle}
              </Typography>
              <Typography variant="medium_1" sx={missionVisionTextTypography(theme)}>
                {aboutFingoData.visionText}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default About;
